/** @jsxImportSource theme-ui */
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import BoxButton from "../../Radiate/NewBoxButton/NewBoxButton"
import HookRow from "./HookRow"
import SandboxHelp from "./SandboxHelp"
import * as Styles from "./styles"

const HookLibrarySection = ({ app, canEdit, reload }) => {
  const { t } = useTranslation(["settings", "common"])
  const [showNew, setShowNew] = useState(false)
  const [conflict, setConflict] = useState(false)

  const hooks = app?.outboundHooks || []

  return (
    <div>
      <SandboxHelp />

      {conflict && (
        <Styles.ConflictBanner>
          <span>
            {t(
              "outbound_hooks.conflict.message",
              "This hook was changed somewhere else. Reload to get the latest version before saving again."
            )}
          </span>
          <BoxButton
            inverted
            icon="sync"
            text={t("common:buttons.reload", "Reload")}
            onClick={() => {
              if (reload) reload()
              setConflict(false)
            }}
          />
        </Styles.ConflictBanner>
      )}

      {canEdit && (
        <div sx={{ display: "flex", justifyContent: "flex-end", my: 2 }}>
          <BoxButton
            primary
            icon="plus"
            text={t("outbound_hooks.new_hook", "New hook")}
            disabled={showNew}
            onClick={() => setShowNew(true)}
          />
        </div>
      )}

      <Styles.HookList>
        {showNew && (
          <HookRow
            isNew
            wAppId={app?.wAppId}
            appRelayId={app?.id}
            canEdit={canEdit}
            onCreated={() => setShowNew(false)}
            onConflict={() => setConflict(true)}
          />
        )}

        {hooks.length === 0 && !showNew && (
          <Styles.EmptyState>
            {t("outbound_hooks.empty", "No outbound hooks yet. Create one to get started.")}
          </Styles.EmptyState>
        )}

        {hooks.map((hook) => (
          <HookRow
            key={hook.id}
            hook={hook}
            wAppId={app?.wAppId}
            appRelayId={app?.id}
            canEdit={canEdit}
            onConflict={() => setConflict(true)}
          />
        ))}
      </Styles.HookList>
    </div>
  )
}

export default HookLibrarySection
